// Category options for the dropdown
const categoryOptions = [
  { value: 'all', label: 'All Categories' },
  { value: 'ANTI-AGING', label: 'ANTI-AGING' },
  { value: 'BRAIN', label: 'BRAIN' },
  { value: 'DIET', label: 'DIET' },
  { value: 'DIGESTION', label: 'DIGESTION' },
  { value: 'HEALTH', label: 'HEALTH' },
  { value: 'HEART', label: 'HEART' },
  { value: 'HYDRATION', label: 'HYDRATION' },
  { value: 'PAIN', label: 'PAIN' },
  { value: 'POTENCY', label: 'POTENCY' },
  { value: 'PROSTATE', label: 'PROSTATE' },
  { value: 'VISION', label: 'VISION' },
  { value: 'WELLNESS', label: 'WELLNESS' }
];

export default categoryOptions;
